import { useSkuSelector } from '../hooks/useSkuSelector';

type FrameAroundProps = {
	selected: boolean;
};

const FrameAround = ({ selected }: FrameAroundProps) => {
	const { blockClass, handles, prodSum } = useSkuSelector();

	const renderClass = () => blockClass && `vtex-store-components-3-x-frameAround--${blockClass}`;

	return (
		<div
			className={`${prodSum ? handles.frameAround : ''} frameAround frameAround--${blockClass} vtex-store-components-3-x-frameAround ${renderClass()} absolute b--action-primary br3 bw1 ${
				selected ? 'ba' : ''
			}`}
		></div>
	);
};

export default FrameAround;
